import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
  savedLanguageMeta: null,
};

const languageMetaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_LANGUAGE_META_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_LANGUAGE_META_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        savedLanguageMeta: action.payload,
      };

    case actionTypes.SAVE_LANGUAGE_META_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
};

export default languageMetaReducer;
